export default __webpack_public_path__ + "static/media/boardCustomType.c4feee35.csv";